module.exports = __webpack_public_path__ + "img/step02_a_stand_power_position_both_feet.9bc3b688.png";